import React, { useState, useEffect } from "react";
import {
    Dialog,
    // Checkbox,
    Button,
    CircularProgress, Box, ListItem, List, ListItemText, useMediaQuery, IconButton
} from '@material-ui/core';
import Checkbox from '../checkbox'
import Typography from '@material-ui/core/Typography';
import { useDataProvider } from 'react-admin';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Loading } from 'react-admin';
import { useTranslate } from 'react-admin';
import IconTitle from './TitleRoleCreate';
import SubItem from './GroupItem';
import { grey } from '@material-ui/core/colors';
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { AppState } from '../types';
import { isBlocking } from './actions';
import { useDispatch } from 'react-redux';
import { shouldBeDisabled } from '../utils';
import { shouldBeDisabledCreate } from '../utils';
import DialogAlertSave from '../common/dialog-alert-save';
import TextButton from "../CustomizedUIs/TextButton";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        Container: {
            width: '800px'
        },
        table: {
            minWidth: 650,
        },
        Button: {
        },
        Card: {
            marginTop: '2em',
            padding: '1em'
        },
        buttonProgress: {
            color: 'blue',
            position: 'absolute',
            left: 23,
            top: 5
        },
        name: {
            width: '25em',
            minWidth: '25em',
            maxWidth: '25em',
            wordBreak: 'break-all'
        }, dialogActions: {
            marginLeft: '25%'
        },
        tableCell: {
            borderBottom: 'solid 5px ' + theme.palette.background.default
        },
        expandText: {
            fontSize: 10,
            fontWeight: 'bold',
            color: grey[500]
        }, expandGroup: {
            width: 150,
            height: 30,
            float: 'right',
            backgroundColor: theme.palette.common.white,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-around'
        }, TextRole: {
            fontFamily: 'UniviaPro-Book',
            fontSize: '13px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            color: '#4f5064',
            paddingLeft: 20,
        }, btnSave: {
            fontFamily: 'UniviaPro-Bold',
            fontSize: '11px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: '0.44px',
            color: '#ffffff',
        }, TitleUnsave: {
            fontFamily: 'UniviaPro-Book',
            fontSize: '22px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.25,
            letterSpacing: 'normal',
            color: 'rgba(0, 0, 0, 0.87)',
        },
        ConstentUnsave: {
            fontFamily: 'UniviaPro-Book',
            fontSize: '12px',
            fontWeight: 'normal',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 1.25,
            letterSpacing: 'normal',
            color: 'rgba(0, 0, 0, 0.87)',
            paddingTop: '10px'
        },
        textClose: {
            fontFamily: 'UniviaPro',
            fontSize: '10px',
            fontWeight: 'bold',
            fontStretch: 'normal',
            fontStyle: 'normal',
            lineHeight: 'normal',
            letterSpacing: '0.4px',
            color: '#4f5064',
        },
        BorderClose: {
            width: '25px',
            height: '25px',
            border: 'solid 2px #e5f1f8',
            backgroundColor: '#ffffff',
            marginLeft: '10px'
        }

    }),
);


const RoleEditTitle = ({ record }: any) => {
    return <span>Role {record ? `"${record.name}"` : ''}</span>;
};

const FunctionContainer = ({ list, onChangeFunction }: any) => {
    const classes = useStyles();
    const isDesktop = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
    return (
        <Box display='flex' width='100%'>
            <Box width='100%'>
                {
                    list.map((item: any) => (
                        <ListItem className={classes.tableCell}>
                            <ListItemText primary={<Typography className={classes.TextRole}>{item.functionName}</Typography>} />
                            <Box display="flex" style={{ alignItems: "center" }} width='79px' mr={isDesktop ? 10 : '86px'}>
                                <Checkbox
                                    disabled={item.disable}
                                    id={item.id + 'isCreate'}
                                    color="primary"
                                    checked={item.isCreate}
                                    size="medium"
                                    onChange={() => onChangeFunction(item, 'EDIT')}
                                />
                            </Box>
                            <Box display="flex" style={{ alignItems: "center" }} width='79px' mr={isDesktop ? 10 : '80px'}>
                                <Checkbox
                                    color="primary"
                                    disabled={item.isCreate === true}
                                    id={item.id + '-read'}
                                    checked={item.isRead}
                                    onChange={() => onChangeFunction(item, 'READ')}
                                />
                            </Box>
                        </ListItem>
                    ))
                }
            </Box>
        </Box>

    );
}
const GroupContainer = ({ entity, onToggleExpand, onUpdateEntities, index, onChangeFunction }: any) => {
    const dispatch = useDispatch();
    const onChangeEntites = (type: string) => {
        dispatch(isBlocking(true))
        // dispatch(changeRole(true))
        const Disable = (func: any) => {
            if (func.id) {
                if (func.id === 27) {
                    return entittyIsCreate
                }
                else if (func.id === 25) {
                    return entittyIsCreate
                }
            }
            if (func.functionId) {
                if (func.functionId === 27) {
                    return entittyIsCreate
                }
                else if (func.functionId === 25) {
                    return entittyIsCreate
                }
            }
        }
        const entityIsRead = type === 'READ' ? !entity.isRead : entity.isRead;
        const entittyIsCreate = type === 'EDIT' ? !entity.isCreate : entity.isCreate;
        const newEntity = {
            ...entity,
            isRead: entityIsRead,
            isCreate: entittyIsCreate,
            functions: entity.functions.map((func: any) => {
                const isRead = type === 'READ' ? entityIsRead : func.isRead ? func.isRead : !entity.isCreate;
                const isCreate = type === 'EDIT' ? entittyIsCreate : func.isCreate;
                return {
                    ...func,
                    isRead,
                    isCreate,
                    disable: Disable(func)
                };
            })
        };
        onUpdateEntities(newEntity, index);
    }

    return (
        <Box display="flex" width='100%' justifyContent='center'>
            <Box width='700px' my={2}>
                <SubItem
                    groupData={entity}
                    countCluster={0}
                    onToggleExpand={onToggleExpand}
                    onChange={onChangeEntites}
                >
                    <List component="div" disablePadding>
                        <FunctionContainer list={entity['functions']} onChangeFunction={onChangeFunction} />
                    </List>
                </SubItem>
            </Box>
        </Box>
    );
}
const RoleEditContainer = (props: any) => {
    const dataProvider = useDataProvider();
    const [expandAll, setExpandAll] = useState(false);
    const [entities, setEntities] = useState([]);
    const [error, setError] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const history = useHistory();
    const classes = useStyles();
    const translate = useTranslate();
    const [textValue, setTextValue] = React.useState({
        role: '',
    });
    let is_blocking = useSelector((state: AppState) => state.is_blocking);
    const path_name = useSelector((state: AppState) => state.path_name);
    const dispatch = useDispatch();

    useEffect(() => {
        dataProvider('GET_LIST', "Function", {
            filter: {

            },
            pagination: {},
            sort: { field: 'id', order: 'ASC' },

        })
            .then((data: any) => {
                const group = data.data.map((datagroup: any) => {
                    const functions = datagroup.functions.map((cls: any) => {
                        // Hardcode checkbox
                        if (cls.id === 25 || cls.id === 27) {
                            return {
                                ...cls,
                                disable: shouldBeDisabledCreate(cls)
                            }
                        }
                        else {
                            return {
                                ...cls,
                                disable: false,
                            }
                        }
                    });
                    return {
                        ...datagroup,
                        functions,
                        expand: false,
                        isAllCreate: false,
                        isAllRead: false,
                    }
                });
                setEntities(group)
                setLoading(false);
            })
            .catch((error: any) => {
                setError(error);
                setLoading(false);
            })
    }, []);
    if (loading) return <Loading />;
    if (error) return null;


    const handleInherit = (value: any) => {
        dataProvider('GET_ONE', "FunctionActions/Roles", {
            id: value
        }).then(({ data }: any) => {
            const group = data.groups.map((datagroup: any) => {
                const functions = datagroup.functions.map((cls: any) => {
                    // Hardcode checkbox
                    if (cls.functionId === 25 || cls.functionId === 27) {
                        return {
                            ...cls,
                            disable: shouldBeDisabled(cls)
                        }
                    }
                    else {
                        return {
                            ...cls,
                            disable: false,
                        }
                    }
                });
                return {
                    ...datagroup,
                    functions,
                    expand: false,
                    isAllCreate: false,
                    isAllRead: false,
                }
            });
            setEntities(group);
            setLoading(false);
        }).catch((error: any) => {
            setLoading(false);
            setError(error);
        });

    }

    const onExpandAllChanged = () => {
        const newgroup = entities.map((datagroup: any) => {
            return {
                ...datagroup,
                expand: !expandAll

            }
        }) as any;
        setEntities(newgroup);
        setExpandAll(!expandAll);

    }
    const onToggleExpand = (node: any) => {
        node.expand = !node.expand;
        const newEntities = entities.map((item: any) => item) as any;
        const index = entities.findIndex((entity: any) => entity.id === node.id)
        if (index !== -1) {
            newEntities[index] = node;
        }
        setEntities(newEntities);
    }


    const onChangeFunction = (func: any, type: string) => {
        dispatch(isBlocking(true))
        const newEntities: any = entities.map((item: any) => {
            const funcs = item.functions.map((funct: any) => {
                if (funct.id === func.id) {
                    const isCreate = type === 'EDIT' ? !funct.isCreate : funct.isCreate;
                    const isRead = type === 'READ' ? !funct.isRead : (!funct.isCreate ? !funct.isCreate : funct.isRead);
                    return {
                        ...funct,
                        isCreate,
                        isRead
                    }
                }
                return funct;
            });
            const sysData = funcs.find((item: any) => item.functionId ? item.functionId === 24 : item.id === 24);
            const log = funcs.find((item: any) => item.functionId === 25 ? item.functionId === 25 : item.id === 25);
            const adminUser = funcs.find((item: any) => item.functionId === 26 ? item.functionId === 26 : item.id === 26);
            const adminFunc = funcs.find((item: any) => item.functionId === 27 ? item.functionId === 27 : item.id === 27);
            if (sysData !== undefined && sysData.isCreate === true) {
                // Check 25
                // Find id 25
                if (log !== undefined) {
                    log.isCreate = true
                    log.disable = true
                    log.isRead = true
                }

            }
            else {
                if (log !== undefined) {
                    log.disable = false
                }
            }

            if (adminUser !== undefined && adminUser.isCreate === true) {
                // Find id 27
                // Check 27
                if (adminFunc !== undefined) {
                    adminFunc.isCreate = true
                    adminFunc.disable = true
                    adminFunc.isRead = true
                }


            } else {
                if (adminFunc !== undefined) {
                    adminFunc.disable = false
                }
            }

            for (let i = 0; i < funcs.length; i++) {
                if (funcs.id === 25) {
                    funcs[i] = log;
                }
                else if (funcs.id === 27) {
                    funcs[i] = adminFunc;
                }
            }
            return {
                ...item,
                functions: funcs
            };
        });
        setEntities(newEntities);

    }


    const onSave = () => {
        setLoading(true)
        is_blocking = false;
        dispatch(isBlocking(is_blocking))
        dataProvider('CREATE', 'roles', {
            data: {
                name: textValue.role,
                entity: entities
            }
        }).then(({ data }: any) => {
            history.push({
                pathname: '/roles',
                state: { open: "true" }
            });
            setLoading(false);
        }).catch((Response: any) => {
            // TODO: Should show error message
            setLoading(false);
            setErrorMessage(translate(`resources.${Response.message}`))
            console.log("Error message", Response.message)

        });
    }
    const onSaveConfirm = () => {
        setLoading(true)
        is_blocking = false;
        dispatch(isBlocking(is_blocking))
        dataProvider('CREATE', 'roles', {
            data: {
                name: textValue.role,
                entity: entities
            }
        }).then(({ data }: any) => {
            history.push({
                pathname: path_name,
                state: { open: "true" }
            });
            setLoading(false);
        }).catch((Response: any) => {
            setLoading(false);
            // TODO: Should show error message
            setErrorMessage(translate(`resources.${Response.message}`))
            console.log("Error message", Response.message)

        });

    }

    const onUpdateEntities = (entity: any, index: number) => {
        const newEntities: any = entities.map((item: any, idx: number) => {
            if (index === idx) {
                return entity;
            }
            return item;
        });
        setEntities(newEntities);
    }

    return (
        <DialogAlertSave onSave={onSaveConfirm}>
            <Box width='95%' m='auto'>
                <Box display='flex'>
                    <IconTitle
                        TitleBack={translate(`resources.role.back`)}
                        TitleName={translate(`resources.role.createRole`)}
                        onExpandAllChanged={(): any => onExpandAllChanged()}
                        expandAll={expandAll}
                        handleInherit={handleInherit}
                        textValue={textValue}
                        setTextValue={setTextValue}
                        errorMessage={errorMessage}
                    />
                </Box>
                {
                    entities.map((entitiy: any, index: number) =>
                        <GroupContainer entity={entitiy} key={entitiy.id} onUpdateEntities={onUpdateEntities} index={index}
                            onToggleExpand={onToggleExpand} onChangeFunction={onChangeFunction}
                        />
                    )}
                <Box display="flex" width='100%' justifyContent='center'>
                    <Box style={{ width: "700px", display: 'flex' }}>
                        <Box marginLeft='auto'>
                            <TextButton
                                style={{ marginTop: "2em", marginRight: '30px' }}
                                component={Link}
                                to={{ pathname: "/roles" }}
                            /> 
                            <Button
                                disabled={loading || textValue.role === ''}
                                className={classes.Button}
                                variant="contained"
                                color="primary"
                                onClick={() => onSave()}
                            >
                                {loading ? <CircularProgress size={24} /> :
                                    <Typography className={classes.btnSave} style={{ paddingLeft: "16px", paddingRight: "16px", paddingTop: '6px', paddingBottom: '6px' }} >
                                        {translate(`resources.role.Save`)}
                                    </Typography>}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </DialogAlertSave>
    );
}

const RoleCreate = (props: any) => {

    return (
        <Box component="div">
            <RoleEditContainer {...props} />
        </Box>
    );
};

export default RoleCreate;
